<template>
  <li v-if="text" class="nav-link" :data-active="isActive(href)" ><a :href="href" >{{ text }}</a></li>
</template>

<script>
export default {
  name: "TranslationLink",
  props: {
    href: String,
    text: String,
  },
  methods: {
    isActive (href) {
      return window.location.pathname.includes(href);
    }
  },
}

</script>

<style lang="scss" scoped>
  .nav-link {
      margin-right: 2em;
      font-size: 13px;

      &:last-child {
        margin-right: 0;
      }

      &[data-active="true"] {
        a {
          font-weight: bold;
        }
      }

      a {
        text-decoration: none;
        color: #000;
      }
    }
  [dir="rtl"] .nav-link {
    margin-right: 0;
    margin-left: 2em;
  }

</style>
